import { render, staticRenderFns } from "./CreateAsociateCifToCertificateDialog.vue?vue&type=template&id=d66bc0c6&scoped=true&"
import script from "./CreateAsociateCifToCertificateDialog.vue?vue&type=script&lang=js&"
export * from "./CreateAsociateCifToCertificateDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d66bc0c6",
  null
  
)

export default component.exports